import api from "../apiConfig";

export const CreateApi = async ({
  product_id,
  stage_id,
  usage_id,
  is_test,
}) => {
  try {
    const resp = await api.post("/api/apikey/create", {
      product_id,
      stage_id,
      usage_id,
      is_test,
    });
    return resp;
  } catch (error) {
    console.log("API Key 신청 에러", error);
    return error;
  }
};
